'use client';

import { apiClient } from '@borradh-workspace/api-client';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { SubmitOptInInput, SubmitOptInResponse } from '../types';

interface UseSubmitOptInOptions {
  organizationSlug: string;
  onSuccess?: () => void;
}

export const useSubmitOptIn = ({
  organizationSlug,
  onSuccess,
}: UseSubmitOptInOptions) => {
  const mutation = useMutation({
    mutationFn: (input: SubmitOptInInput) =>
      apiClient.post<SubmitOptInResponse>(
        `public/opt-in/${organizationSlug}/submit`,
        input
      ),
    onSuccess: () => onSuccess?.(),
    onError: (error: Error) =>
      toast.error(error.message || 'Could not record your opt-in'),
  });

  return {
    submitOptIn: mutation.mutate,
    isSubmitting: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};
